var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 36C20.0003 36 32.522 24.8696 32.522 16.5217C32.522 9.60617 26.9158 4 20.0003 4C13.0847 4 7.47852 9.60617 7.47852 16.5217C7.47852 24.8696 20.0003 36 20.0003 36Z",
    stroke: "#951345",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0008 16.0003C24.0008 18.2094 22.2099 20.0003 20.0008 20.0003C17.7916 20.0003 16.0008 18.2094 16.0008 16.0003C16.0008 13.7911 17.7916 12.0003 20.0008 12.0003C22.2099 12.0003 24.0008 13.7911 24.0008 16.0003Z",
    stroke: "#951345",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker02);
export default __webpack_public_path__ + "static/media/marker-02.0922d5c93d8ed434f40acc31837021f2.svg";
export { ForwardRef as ReactComponent };